<template>
  <c-modal size="lg" title='Data interval' v-model="open">
    <c-scroll-view style="height:600px">
    <c-form layout="horizontal">
      <c-form-field label="From">
        <date-picker v-model="startDate" lang="en"></date-picker>
      </c-form-field>
      <c-form-field label="To">
        <date-picker v-model="endDate" lang="en"></date-picker>
      </c-form-field>
      <c-form-field>
        <c-button @click.prevent="onSave" smart type="primary">Download data</c-button>
        <c-button @click.prevent="onClose" smart >Close</c-button>
      </c-form-field>
    </c-form>
      </c-scroll-view>
  </c-modal>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
import axios from 'axios'
import download from 'downloadjs'
import DatePicker from '../vue2-datepicker'

export default {
  name: 'UserStatisticsFilter',

  components: {
    DatePicker
  },

  computed: {
    ...mapState('auth', ['clientCode', 'clientId'])
  },

  data () {
    return {
      open: false,
      startDate: new Date(),
      endDate: new Date()
    }
  },
  methods: {
    downloadData () {
      this.open = true
    },

    onClose () {
      this.open = false
    },

    onSave () {
      let d1 = moment(this.startDate)
      let d2 = moment(this.endDate)
      d2.add(1, 'd')
      d1.utc()
      d2.utc()
      let url = process.env.API + this.clientCode + '/results/statistics/download'
      url += '?startDate=' + d1.toJSON() + '&endDate=' + d2.toJSON()

      axios.get(url, {
        responseType: 'blob'
      })
        .then(response => {
          // const suggestedFileName = response.headers[fileNameHeader]
          const suggestedFileName = 'requests.xlsx'
          download(response.data, suggestedFileName)
        })

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserStatisticsFilter.vue